import appearenceNone from './appearenceNone';
import clearFloat from './clearFloat';

const mixins = {
  appearenceNone: appearenceNone,
  clearFloat: clearFloat
}

export { mixins };